import React from "react";
import styled from "styled-components";

type SizeVariant = "normal" | "large";

type EntityAvatarProps = {
    className?: string;
    variant: SizeVariant;
    children: React.ReactNode;
};

const EntityAvatar = ({
    className,
    variant,
    children,
}: EntityAvatarProps): JSX.Element => {
    return (
        <Container
            variant={variant}
            className={`text-center rounded-circle fw-bolder ${
                className || ""
            }`}
        >
            {children}
        </Container>
    );
};

const Container = styled.span<{ variant: SizeVariant }>`
    display: inline-block;
    // box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
    color: #333333;
    border: 1px solid #333;

    ${(props) =>
        props.variant === "normal" &&
        `
        width: 24px;
        height: 24px;
        line-height: 24px;
    `}

    ${(props) =>
        props.variant === "large" &&
        `
        width: 60px;
        height: 60px;
        line-height: 60px;
    `}
`;

export default EntityAvatar;
